import { ClubApi } from 'api'
import PropTypes from 'prop-types'
import { withErrorBoundary, connected } from 'shared'
import { TopLevelPage, ModelGrid } from 'ui'

const Group = ({ match }) => {
  let id = match.params.id
  let models = ClubApi.kick('joined')

  return (
    <TopLevelPage className="Parks" modelId={id} base='/groups' pageTitle={"My Clubs and Groups"}>
      <h1 className="visually-hidden">
        My Clubs and Groups
      </h1>
      <ModelGrid models={models} base={'/groups'} />
    </TopLevelPage>
  )
}

Group.propTypes = {
  match: PropTypes.object,
}

export default withErrorBoundary(connected(Group))
